'use client';

import { c as _c } from "react/compiler-runtime";
import { Spinner, SpinnerSize } from '@components/spinner';
import { IconTooltip } from '@components/icon-tooltip';
import { IconNames } from '@components/icon';
import * as React from 'react';
const LoadingSkeleton: React.FC = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex items-center justify-center "><Spinner size={SpinnerSize.SIZE_SMALL} /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="items-center justify-center"><span className="flex text-[14px] font-light text-center text-gray-dark">Comparing prices on other platforms</span></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex items-center rounded-md bg-primary-xlight p-2"><div className="flex items-center justify-between w-full space-x-2 px-2">{t0}{t1}<div className="flex items-center justify-center mt-0.5"><IconTooltip icon={IconNames.QUESTION_CIRCLE} placement="top">Savvy is comparing prices on other platforms</IconTooltip></div></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export default LoadingSkeleton;